"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = Button;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Button.css");
var _excluded = ["size", "variant", "iconOnly", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * @typedef {Object} ButtonOwnProps
 * @property {'xs'|'sm'|'md'|'lg'} size
 * @property {'primary'|'secondary'|'secondary-color'|'tertiary'|'tertiary-color'|'link'|'link-color'|'danger'|'success'} variant
 * @property {boolean} iconOnly
 *
 * @typedef {ButtonOwnProps & React.ButtonHTMLAttributes<HTMLButtonElement>} ButtonProps
 */

/**
 *
 * @param {ButtonProps} props
 * @returns {React.ReactElement}
 */
function Button(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$iconOnly = _ref.iconOnly,
    iconOnly = _ref$iconOnly === void 0 ? false : _ref$iconOnly,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("button", _extends({}, props, {
    className: (0, _classnames["default"])('ap-button', "ap-button--".concat(size), "ap-button--".concat(variant), iconOnly && 'ap-button--icon-only', className)
  }));
}